<vl-widget-title [text]="'stats_ligne.main_oeuvre_ligne' | trans" [widget]="widget()">
  <ng-content/>
  <vl-chips-toggle [elements]="elementsView" [(value)]="viewType" type="icon"/>
  <vl-aide-context [sections]="aideSections"/>
</vl-widget-title>

@if (stats() === null) {
  <vl-loader-skeleton/>
} @else if (viewType() === 'PIE') {
  @if (values().length) {
    <div class="flex-row w100 widget-content fade-in">
      <div class="w40 overflow-hidden">
        <canvas #moChart></canvas>
      </div>
      <div class="flex-col w60 overflow-scroll gap-4">
        @for (item of legendLabels(); track $index) {
          <div class="flex-row gap-8 p-8 border-on-disabled border-box border-8 align-center">
            <span [style.background-color]="item.color" class="w-16 h-16 border-full shrink-0"></span>
            @if (item.key !== ('stats_ligne.autres' | trans)) {
              <vl-user-info-card class="grow min-w-0" [userInfosId]="item.key" size="small"/>
            } @else {
              <span class="grow caption on-background-alt">{{ 'stats_ligne.autres' | trans }}</span>
            }
            <span class="caption on-disabled shrink-0">{{ item.percentage | numberSig:{minDecimals: 0, maxDecimals: 1} }}%</span>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="flex-row align-center justify-center h100 on-disabled">
      {{ 'stats_ligne.aucune_donnee' | trans }}
    </div>
  }
} @else {
  <div class="list-container">
    @if (listRows().length) {
      <table class="w100">
        <thead>
        <tr>
          <th class="text-left">{{ 'stats_ligne.utilisateur' | trans }}</th>
          <th class="text-right">{{ 'stats_ligne.duree' | trans }}</th>
          <th class="text-right">{{ 'stats_ligne.part' | trans }}</th>
        </tr>
        </thead>
        <tbody>
        @for (row of listRows(); track row.key) {
          <tr>
            <td>
              @if (row.key !== ('stats_ligne.autres' | trans)) {
                <vl-user-info-card [userInfosId]="row.key" size="small"/>
              } @else {
                <span class="caption on-background-alt">{{ 'stats_ligne.autres' | trans }}</span>
              }
            </td>
            <td class="text-right">{{ formatMinutes(row.value) }}</td>
            <td class="text-right">{{ row.pct | numberSig:{minDecimals: 0, maxDecimals: 1} }}%</td>
          </tr>
        }
        </tbody>
      </table>
    } @else {
      <div class="flex-row align-center justify-center h100 on-disabled">
        {{ 'stats_ligne.aucune_donnee' | trans }}
      </div>
    }
  </div>
}
